/*--------------
V 1.0.0 - Criado por Larner Diogo

DESCIÇÃO:
Componente para rotas autenticadas


COMPONENTS
***********************************************************/
import { Component } from '@angular/core';

@Component({
  selector: 'app-authorization',
  templateUrl: './index.html'
})
export class AuthorizationComponent { }



// WEBPACK FOOTER //
// ./src/app/authorization/index.ts